import { Link } from "react-router-dom";

// Section label (gold uppercase)
export const Eyebrow = ({ children, light = false }) => (
  <span className={`text-xs uppercase tracking-[0.24em] font-bold ${light ? "text-gold-400" : "text-gold-600"}`}>
    {children}
  </span>
);

// Page hero banner
export const PageHero = ({ eyebrow, title, subtitle }) => (
  <section className="bg-navy-900 relative overflow-hidden" data-testid="page-hero">
    <div className="absolute inset-0 noise-overlay opacity-[0.05]" />
    <div className="absolute -right-20 -top-20 w-80 h-80 border border-gold-500/20 rounded-full" />
    <div className="absolute -right-10 -bottom-32 w-96 h-96 border border-gold-500/10 rounded-full" />
    <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-20 md:py-28">
      <Eyebrow light>{eyebrow}</Eyebrow>
      <h1 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold text-white tracking-tight max-w-3xl">{title}</h1>
      {subtitle && <p className="mt-5 text-base md:text-lg text-white/70 max-w-2xl leading-relaxed">{subtitle}</p>}
    </div>
  </section>
);

export const PrimaryButton = ({ to, href, children, className = "", ...props }) => {
  const cls = `inline-flex items-center justify-center gap-2 bg-navy-900 hover:bg-navy-500 text-white font-bold text-sm uppercase tracking-[0.1em] px-8 py-4 transition-colors duration-200 ${className}`;
  if (to) return <Link to={to} className={cls} {...props}>{children}</Link>;
  return <a href={href} className={cls} {...props}>{children}</a>;
};

export const GoldButton = ({ to, href, children, className = "", type, ...props }) => {
  const cls = `inline-flex items-center justify-center gap-2 bg-gold-500 hover:bg-gold-400 text-navy-900 font-bold text-sm uppercase tracking-[0.1em] px-8 py-4 transition-colors duration-200 disabled:opacity-60 ${className}`;
  if (to) return <Link to={to} className={cls} {...props}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...props}>{children}</a>;
  return <button type={type} className={cls} {...props}>{children}</button>;
};
